export const USER_ERROR = 'USER_ERROR';
export const USER_GET = 'USER_GET';
export const USER_LOADING = 'USER_LOADING';
export const USER_UPDATED = 'USER_UPDATED';
export const COACHEES_GET = 'COACHEES_GET';
export const COACHEE_GET = 'COACHEE_GET';
export const COACH_GET = 'COACH_GET';
export const PREVIOUS_COACH_GET = 'PREVIOUS_COACH_GET';
